import { isMaxByteLength } from '#src/app/shared/utils/validators';

import type { NonI18nFieldValidator, WithNonI18nConfig } from './shared/types';

export function nonI18nMaxByteLengthValidator({
	message,
	length,
}: WithNonI18nConfig<{ length: number }>): NonI18nFieldValidator<string | undefined> {
	return (value) => (!value || isMaxByteLength(value, length) ? undefined : message);
}
